import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Input,
  Menu,
  Slide,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
import NoteItem from "./NoteItem";
import { useAddPatientNote } from "utils/hooks/apiHooks/notes-feature/useAddPatientNote";
import { useFetchPatientNotes } from "utils/hooks/apiHooks/notes-feature/useFetchPatientNotes";
import { useUpdatePinnedLog } from "utils/hooks/apiHooks/notes-feature/useUpdatePinnedLog";
import { NoteLog } from "types/common";
import { useUpdateNote } from "utils/hooks/apiHooks/notes-feature/useUpdateNote";
import UpsertNoteDialog from "./UpsertNoteDialog";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    // backgroundColor: theme.palette.background.paper,
  },
}));
const Transition = React.forwardRef(function Transition(props, ref) {
  // @ts-ignore
  return <Slide direction="top" ref={ref} {...props} />;
});

export default function Notes({
  open,
  setOpenNotes,
  data,
  refetch,
  patientId,
}: any) {
  const [updatePinned, loadingUpdatePinned] = useUpdatePinnedLog(refetch);
  const { mutate: addNote, isLoading, error } = useAddPatientNote(refetch);

  const [openEditDialog, setOpenEditDialog] = useState(false);

  const handleAddNote = (note: string) => {
    addNote(
      {
        note: {
          patient_id: patientId,
          description: note,
        },
      },
      {
        onSuccess: () => {
          setOpenEditDialog(false);
        },
        onError: (err) => {
          console.error("Error adding note:", err);
        },
      }
    );
  };

  return (
    <Dialog
      // @ts-ignore
      TransitionComponent={Transition}
      open={open}
      onClose={() => {
        setOpenNotes(false);
      }}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <p>Notes</p>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setOpenEditDialog(true);
            }}
          >
            Add A Note
          </Button>
        </div>
      </DialogTitle>

      <DialogContent>
        {data?.map((item: NoteLog) => (
          <NoteItem
            key={item.id}
            logId={item.id}
            content={item.description}
            foldColor="white"
            isPinned={item.is_pinned}
            fullWidth
          />
        ))}
        <br />
        <br />
      </DialogContent>

      <UpsertNoteDialog
        open={openEditDialog}
        initialValue={""}
        handleAddNote={handleAddNote}
        close={() => {
          setOpenEditDialog(false);
        }}
      />
    </Dialog>
  );
}
